function escapeHtml(value) {
  return String(value !== null && value !== void 0 ? value : '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function waitingLabel(transfer) {
  if (transfer.status === 'inbound_broadcast') {
    return 'Waiting for provider confirmation';
  }
  if (transfer.status === 'inbound_confirmed') {
    return 'Waiting for SAITO issuance';
  }
  if (transfer.status === 'outbound_awaiting') {
    return 'Waiting for issuance broadcast';
  }
  if (transfer.status === 'outbound_broadcast') {
    return 'Waiting for chain inclusion';
  }
  if (transfer.status === 'treasury_submitted') {
    return 'Waiting for treasury acknowledgment';
  }
  if (transfer.status === 'treasury_accepted') {
    return 'Accepted by treasury';
  }
  if (transfer.status === 'treasury_rejected') {
    return 'Rejected by treasury';
  }
  if (transfer.purpose === 'migration' && transfer.mode === 'manual') {
    if (transfer.status === 'inbound_confirmed') {
      return 'Waiting for administrator issuance';
    }
    return 'Waiting for deposit verification';
  }
  return 'No administrative action for this status';
}
function blockingExplanation(transfer) {
  if (transfer.last_error === 'insufficient_funds') {
    return 'Blocked: not enough SAITO is available to issue this transfer.';
  }
  if (transfer.last_error) {
    return transfer.last_error;
  }
  return '';
}
function actionControl(transfer, advancing) {
  var _transfer$action, _transfer$action2;
  var blocked = blockingExplanation(transfer);
  if (blocked) {
    return "<span class=\"admin-payments-blocked\">".concat(escapeHtml(blocked), "</span>");
  }
  var disabled = advancing ? 'disabled' : '';
  if (transfer.purpose === 'migration' && transfer.mode === 'manual' && transfer.status === 'inbound_confirmed' && transfer.outbound_amount && !transfer.outbound_tx_sig) {
    return "<button type=\"button\" class=\"admin-button admin-payments-action\" data-payment-id=\"".concat(escapeHtml(transfer.id), "\" data-payment-action=\"approve-migration\" ").concat(disabled, ">Issue SAITO</button>");
  }
  if (transfer.purpose === 'migration' && transfer.mode === 'manual' && (transfer.status === 'inbound_awaiting' || transfer.status === 'inbound_broadcast')) {
    return "<input class=\"admin-input\" data-migration-amount=\"".concat(escapeHtml(transfer.id), "\" placeholder=\"Verified amount\" ").concat(disabled, " /><input class=\"admin-input\" data-migration-hash=\"").concat(escapeHtml(transfer.id), "\" placeholder=\"Deposit hash\" ").concat(disabled, " /><button type=\"button\" class=\"admin-button admin-payments-action\" data-payment-id=\"").concat(escapeHtml(transfer.id), "\" data-payment-action=\"verify-migration\" ").concat(disabled, ">Verify deposit</button>");
  }
  if ((_transfer$action = transfer.action) !== null && _transfer$action !== void 0 && _transfer$action.action && (_transfer$action2 = transfer.action) !== null && _transfer$action2 !== void 0 && _transfer$action2.label) {
    return "<button type=\"button\" class=\"admin-button admin-payments-action\" data-payment-id=\"".concat(escapeHtml(transfer.id), "\" data-payment-action=\"").concat(escapeHtml(transfer.action.action), "\" ").concat(disabled, ">").concat(escapeHtml(transfer.action.label), "</button>");
  }
  return "<span class=\"admin-payments-waiting\">".concat(escapeHtml(waitingLabel(transfer)), "</span>");
}
function identifierCell(value) {
  var text = String(value || '');
  if (!text) {
    return '';
  }
  return "<div class=\"admin-payments-key\" title=\"".concat(escapeHtml(text), "\">").concat(escapeHtml(text), "</div>");
}
function accountPanel(account) {
  return "\n    <section class=\"admin-payments-section\">\n      <h2>Account Information</h2>\n      <textarea class=\"admin-input admin-payments-backup\" id=\"admin-payments-account-backup\" readonly rows=\"8\" aria-label=\"Account Information\">".concat(escapeHtml(account.backup || ''), "</textarea>\n    </section>\n  ");
}
function apiKeyPanel(apiKeyText, savingApiKey) {
  var disabled = savingApiKey ? 'disabled' : '';
  return "\n    <div class=\"admin-payments-setup\">\n      <p class=\"admin-payments-note\">In order to enable web3 payments, please provide a Mixin Access Key:</p>\n      <textarea class=\"admin-input admin-payments-backup\" id=\"admin-payments-api-key\" rows=\"8\" ".concat(disabled, ">").concat(escapeHtml(apiKeyText || ''), "</textarea>\n      <button type=\"button\" class=\"admin-button\" id=\"admin-payments-api-key-submit\" ").concat(disabled, ">Submit</button>\n    </div>\n  ");
}
function setupPanel(creating, restoring, restoreText) {
  var disabled = creating || restoring ? 'disabled' : '';
  return "\n    <div class=\"admin-payments-setup\">\n      <p class=\"admin-payments-note\">In order to setup web3 payment processing with Saito, you must create a Mixin Account for your server. This account will be used to fetch real-time price information and the status of cryptocurrency transfers on other networks:</p>\n      <button type=\"button\" class=\"admin-button\" id=\"admin-payments-create-account\" ".concat(disabled, ">create account</button>\n      <label class=\"admin-payments-label\" for=\"admin-payments-restore-account\">Or restore a saved account</label>\n      <textarea class=\"admin-input admin-payments-backup\" id=\"admin-payments-restore-account\" rows=\"8\" ").concat(disabled, ">").concat(escapeHtml(restoreText || ''), "</textarea>\n      <button type=\"button\" class=\"admin-button\" id=\"admin-payments-restore-account-button\" ").concat(disabled, ">restore account</button>\n    </div>\n  ");
}
var MODE_OPTIONS = [{
  fulfillment_mode: 'local',
  payout_mode: 'local',
  label: 'Local Fulfillment - Local Payouts'
}, {
  fulfillment_mode: 'local',
  payout_mode: 'remote',
  label: 'Local Fulfillment - Remote Payouts'
}, {
  fulfillment_mode: 'remote',
  payout_mode: 'remote',
  label: 'Remote Fulfillment - Remote Payouts'
}, {
  fulfillment_mode: 'treasury',
  payout_mode: 'local',
  label: 'Local Fulfillment - Treasury Node'
}];
function modeOptionValue(fulfillment_mode, payout_mode) {
  return "".concat(fulfillment_mode, ":").concat(payout_mode);
}
function keyListPanel(_ref) {
  var title = _ref.title,
    description = _ref.description,
    keys = _ref.keys,
    draft = _ref.draft,
    kind = _ref.kind,
    saving = _ref.saving;
  var rows = Array.isArray(keys) ? keys : [];
  var disabled = saving ? 'disabled' : '';
  var body = rows.length ? "<ul class=\"admin-payments-key-list\">\n        ".concat(rows.map(function (key) {
    return "<li class=\"admin-payments-key-item\">\n              <code class=\"admin-payments-key-value\">".concat(escapeHtml(key), "</code>\n              <button type=\"button\" class=\"admin-button-quiet\" data-payments-remove-key=\"").concat(escapeHtml(kind), "\" data-payments-key=\"").concat(escapeHtml(key), "\" ").concat(disabled, ">Remove</button>\n            </li>");
  }).join(''), "\n      </ul>") : "<p class=\"admin-payments-empty\">No public keys configured.</p>";
  return "<div class=\"admin-payments-key-panel\" data-payments-key-kind=\"".concat(escapeHtml(kind), "\">\n      <h3>").concat(escapeHtml(title), "</h3>\n      <p class=\"admin-payments-note\">").concat(escapeHtml(description), "</p>\n      ").concat(body, "\n      <div class=\"admin-payments-key-add\">\n        <input class=\"admin-input\" id=\"admin-payments-").concat(escapeHtml(kind), "-key\" type=\"text\" value=\"").concat(escapeHtml(draft || ''), "\" placeholder=\"Saito public key\" ").concat(disabled, " />\n        <button type=\"button\" class=\"admin-button\" data-payments-add-key=\"").concat(escapeHtml(kind), "\" ").concat(disabled, ">Add</button>\n      </div>\n    </div>");
}
function modeSection(_ref2) {
  var _ref2$fulfillment_mod = _ref2.fulfillment_mode,
    fulfillment_mode = _ref2$fulfillment_mod === void 0 ? 'local' : _ref2$fulfillment_mod,
    _ref2$payout_mode = _ref2.payout_mode,
    payout_mode = _ref2$payout_mode === void 0 ? 'local' : _ref2$payout_mode,
    _ref2$treasury_provid = _ref2.treasury_provider_publickeys,
    treasury_provider_publickeys = _ref2$treasury_provid === void 0 ? [] : _ref2$treasury_provid,
    _ref2$treasury_delega = _ref2.treasury_delegate_publickeys,
    treasury_delegate_publickeys = _ref2$treasury_delega === void 0 ? [] : _ref2$treasury_delega,
    _ref2$treasury_provid2 = _ref2.treasury_provider_draft,
    treasury_provider_draft = _ref2$treasury_provid2 === void 0 ? '' : _ref2$treasury_provid2,
    _ref2$treasury_delega2 = _ref2.treasury_delegate_draft,
    treasury_delegate_draft = _ref2$treasury_delega2 === void 0 ? '' : _ref2$treasury_delega2,
    _ref2$savingConfig = _ref2.savingConfig,
    savingConfig = _ref2$savingConfig === void 0 ? false : _ref2$savingConfig,
    _ref2$notice = _ref2.notice,
    notice = _ref2$notice === void 0 ? '' : _ref2$notice;
  var selected = modeOptionValue(fulfillment_mode, payout_mode);
  var supported = MODE_OPTIONS.some(function (option) {
    return option.fulfillment_mode === fulfillment_mode && option.payout_mode === payout_mode;
  });
  var disabled = savingConfig ? 'disabled' : '';
  var options = MODE_OPTIONS.map(function (option) {
    var value = modeOptionValue(option.fulfillment_mode, option.payout_mode);
    return "<option value=\"".concat(escapeHtml(value), "\" ").concat(supported && value === selected ? 'selected' : '', ">").concat(escapeHtml(option.label), "</option>");
  }).join('');
  var keys = '';
  if (fulfillment_mode === 'local' && payout_mode === 'remote' || fulfillment_mode === 'remote' && payout_mode === 'remote') {
    keys = keyListPanel({
      title: 'Treasury Provider Keys',
      description: fulfillment_mode === 'remote' ? 'Add at least one Treasury node public key. This server will tunnel all requests directly to a configured provider.' : 'Add at least one Treasury node public key. This server will send payout requests to a configured provider.',
      keys: treasury_provider_publickeys,
      draft: treasury_provider_draft,
      kind: 'provider',
      saving: savingConfig
    });
  } else if (fulfillment_mode === 'treasury' && payout_mode === 'local') {
    keys = keyListPanel({
      title: 'Authorized Delegate Keys',
      description: 'Configure exactly one services delegate. That node may forward fulfillment requests and relay browser payment notifications for this treasury.',
      keys: treasury_delegate_publickeys,
      draft: treasury_delegate_draft,
      kind: 'delegate',
      saving: savingConfig
    });
  }
  return "<section class=\"admin-payments-section admin-payments-operation\">\n      <h2>Fulfillment and Payout</h2>\n      <div class=\"admin-payments-operation-controls\">\n        <select class=\"admin-input\" id=\"admin-payments-mode\" aria-label=\"Fulfillment and payout configuration\" ".concat(disabled, ">\n          ").concat(options, "\n        </select>\n        <button type=\"button\" class=\"admin-button\" id=\"admin-payments-mode-save\" ").concat(disabled, ">\n          ").concat(savingConfig ? 'Saving…' : 'Save', "\n        </button>\n      </div>\n      ").concat(keys, "\n      ").concat(notice ? "<div class=\"admin-payments-notice\">".concat(escapeHtml(notice), "</div>") : '', "\n    </section>");
}
function reservationStatus(entry) {
  if (entry.reservable) {
    return 'Available';
  }
  var until = Number(entry.reserved_until);
  if (!Number.isFinite(until) || until <= 0) {
    return 'Reserved';
  }
  return "<span class=\"admin-payments-reservation\" data-reserved-until=\"".concat(escapeHtml(String(until)), "\">Reserved</span>");
}
function depositSection(addresses) {
  var rows = Array.isArray(addresses) ? addresses : [];
  var body = rows.length ? "<div class=\"admin-payments-table-wrap\"><table class=\"admin-payments-table\">\n          <thead>\n            <tr>\n              <th>Address</th>\n              <th>Asset</th>\n              <th>Balance</th>\n              <th>Reservation</th>\n            </tr>\n          </thead>\n          <tbody>\n            ".concat(rows.map(function (entry) {
    var asset = entry.ticker || entry.asset_id || '';
    return "<tr>\n              <td>".concat(identifierCell(entry.address), "</td>\n              <td>").concat(escapeHtml(asset), "</td>\n              <td>").concat(escapeHtml(entry.balance || '0'), "</td>\n              <td>").concat(reservationStatus(entry), "</td>\n            </tr>");
  }).join(''), "\n          </tbody>\n        </table></div>") : "<p class=\"admin-payments-empty\">No deposit addresses.</p>";
  return "<section class=\"admin-payments-section\">\n      <h2>Deposit Addresses</h2>\n      ".concat(body, "\n    </section>");
}
function transferTable(rows, advancing) {
  return "<div class=\"admin-payments-table-wrap\"><table class=\"admin-payments-table\">\n          <thead>\n            <tr>\n              <th>ID</th>\n              <th>Purpose</th>\n              <th>Owner</th>\n              <th>IN</th>\n              <th>OUT</th>\n              <th>Status</th>\n              <th>Action</th>\n            </tr>\n          </thead>\n          <tbody>\n            ".concat(rows.map(function (transfer) {
    var owner = transfer.requester_publickey || transfer.recipient_publickey || transfer.publickey || '';
    var remote = transfer.inbound_sender || transfer.inbound_address || '';
    var inbound = "".concat(transfer.inbound_amount || '', " ").concat(transfer.inbound_ticker || '').trim();
    var outbound = "".concat(transfer.outbound_amount || '', " ").concat(transfer.outbound_ticker || '').trim();
    return "<tr>\n              <td>".concat(escapeHtml(transfer.id), "</td>\n              <td>").concat(escapeHtml(transfer.purpose || ''), "</td>\n              <td>").concat(identifierCell(owner), "</td>\n              <td>").concat(escapeHtml(inbound)).concat(identifierCell(remote)).concat(identifierCell(transfer.inbound_tx_hash), "</td>\n              <td>").concat(escapeHtml(outbound), "</td>\n              <td>").concat(escapeHtml(transfer.status), "</td>\n              <td>\n                <div class=\"admin-payments-actions\">\n                  ").concat(actionControl(transfer, advancing), "\n                  <button type=\"button\" class=\"admin-payments-trash\" data-payment-id=\"").concat(escapeHtml(transfer.id), "\" data-payment-action=\"exclude-transfer\" aria-label=\"Trash\" title=\"Trash\" ").concat(advancing ? 'disabled' : '', "><i class=\"fa-solid fa-trash\" aria-hidden=\"true\"></i></button>\n                </div>\n              </td>\n            </tr>");
  }).join(''), "\n          </tbody>\n        </table></div>");
}
function pagination(page, total) {
  var pageSize = 20;
  var pages = Math.max(1, Math.ceil(Number(total || 0) / pageSize));
  var current = Number(page) || 1;
  return "<div class=\"admin-payments-pagination\">\n      <button type=\"button\" class=\"admin-button-icon\" data-payments-page=\"".concat(current - 1, "\" ").concat(current <= 1 ? 'disabled' : '', " title=\"Previous page\" aria-label=\"Previous page\">\n        <i class=\"fa-solid fa-angles-left\" aria-hidden=\"true\"></i>\n      </button>\n      <span>Page ").concat(current, " of ").concat(pages, "</span>\n      <button type=\"button\" class=\"admin-button-icon\" data-payments-page=\"").concat(current + 1, "\" ").concat(current >= pages ? 'disabled' : '', " title=\"Next page\" aria-label=\"Next page\">\n        <i class=\"fa-solid fa-angles-right\" aria-hidden=\"true\"></i>\n      </button>\n    </div>");
}
function paymentsTabs(active) {
  var tabs = [{
    id: 'transfers',
    label: 'Transfers'
  }, {
    id: 'addresses',
    label: 'Addresses'
  }, {
    id: 'config',
    label: 'Config'
  }];
  return "<nav class=\"admin-payments-tabs\" aria-label=\"Payments sections\">\n      ".concat(tabs.map(function (tab) {
    return "<button type=\"button\" class=\"admin-payments-tab".concat(tab.id === active ? ' active' : '', "\" data-payments-tab=\"").concat(tab.id, "\" ").concat(tab.id === active ? 'aria-current="page"' : '', ">").concat(tab.label, "</button>");
  }).join(''), "\n    </nav>");
}
function transfersTab(_ref3) {
  var rows = _ref3.rows,
    search = _ref3.search,
    purpose = _ref3.purpose,
    advancing = _ref3.advancing,
    page = _ref3.page,
    total = _ref3.total;
  return "<section class=\"admin-payments-section\">\n      <form id=\"admin-payments-search-form\" class=\"admin-payments-search\">\n        <input class=\"admin-input\" id=\"admin-payments-search\" type=\"search\" value=\"".concat(escapeHtml(search), "\" placeholder=\"search for transfers...\" />\n        <button type=\"submit\" class=\"admin-button\">Search</button>\n        <select class=\"admin-input admin-payments-purpose\" id=\"admin-payments-purpose\" aria-label=\"Transfer type\">\n          <option value=\"\" ").concat(purpose ? '' : 'selected', ">all transfers</option>\n          <option value=\"migration\" ").concat(purpose === 'migration' ? 'selected' : '', ">migration</option>\n          <option value=\"buysaito\" ").concat(purpose === 'buysaito' ? 'selected' : '', ">buy saito</option>\n        </select>\n      </form>\n      ").concat(rows.length ? transferTable(rows, advancing) : "<p class=\"admin-payments-empty\">No pending transfers.</p>", "\n      ").concat(pagination(page, total), "\n    </section>");
}
function configTab(opts) {
  var _opts$account;
  var account = (_opts$account = opts.account) !== null && _opts$account !== void 0 && _opts$account.user_id ? accountPanel(opts.account) : '';
  return "".concat(account, "\n    ").concat(modeSection({
    fulfillment_mode: opts.fulfillment_mode,
    payout_mode: opts.payout_mode,
    treasury_provider_publickeys: opts.treasury_provider_publickeys,
    treasury_delegate_publickeys: opts.treasury_delegate_publickeys,
    treasury_provider_draft: opts.treasury_provider_draft,
    treasury_delegate_draft: opts.treasury_delegate_draft,
    savingConfig: opts.savingConfig,
    notice: opts.configNotice
  }));
}
module.exports = function () {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref4$transfers = _ref4.transfers,
    transfers = _ref4$transfers === void 0 ? [] : _ref4$transfers,
    _ref4$account = _ref4.account,
    account = _ref4$account === void 0 ? undefined : _ref4$account,
    _ref4$error = _ref4.error,
    error = _ref4$error === void 0 ? '' : _ref4$error,
    _ref4$loading = _ref4.loading,
    loading = _ref4$loading === void 0 ? false : _ref4$loading,
    _ref4$advancing = _ref4.advancing,
    advancing = _ref4$advancing === void 0 ? false : _ref4$advancing,
    _ref4$creating = _ref4.creating,
    creating = _ref4$creating === void 0 ? false : _ref4$creating,
    _ref4$restoring = _ref4.restoring,
    restoring = _ref4$restoring === void 0 ? false : _ref4$restoring,
    _ref4$restoreText = _ref4.restoreText,
    restoreText = _ref4$restoreText === void 0 ? '' : _ref4$restoreText,
    _ref4$search = _ref4.search,
    search = _ref4$search === void 0 ? '' : _ref4$search,
    _ref4$purpose = _ref4.purpose,
    purpose = _ref4$purpose === void 0 ? '' : _ref4$purpose,
    _ref4$page = _ref4.page,
    page = _ref4$page === void 0 ? 1 : _ref4$page,
    _ref4$total = _ref4.total,
    total = _ref4$total === void 0 ? 0 : _ref4$total,
    _ref4$apiKeyConfigure = _ref4.apiKeyConfigured,
    apiKeyConfigured = _ref4$apiKeyConfigure === void 0 ? undefined : _ref4$apiKeyConfigure,
    _ref4$apiKeyText = _ref4.apiKeyText,
    apiKeyText = _ref4$apiKeyText === void 0 ? '' : _ref4$apiKeyText,
    _ref4$savingApiKey = _ref4.savingApiKey,
    savingApiKey = _ref4$savingApiKey === void 0 ? false : _ref4$savingApiKey,
    _ref4$depositAddresse = _ref4.depositAddresses,
    depositAddresses = _ref4$depositAddresse === void 0 ? [] : _ref4$depositAddresse,
    _ref4$fulfillment_mod = _ref4.fulfillment_mode,
    fulfillment_mode = _ref4$fulfillment_mod === void 0 ? 'local' : _ref4$fulfillment_mod,
    _ref4$payout_mode = _ref4.payout_mode,
    payout_mode = _ref4$payout_mode === void 0 ? 'local' : _ref4$payout_mode,
    _ref4$treasury_provid = _ref4.treasury_provider_publickeys,
    treasury_provider_publickeys = _ref4$treasury_provid === void 0 ? [] : _ref4$treasury_provid,
    _ref4$treasury_delega = _ref4.treasury_delegate_publickeys,
    treasury_delegate_publickeys = _ref4$treasury_delega === void 0 ? [] : _ref4$treasury_delega,
    _ref4$treasury_provid2 = _ref4.treasury_provider_draft,
    treasury_provider_draft = _ref4$treasury_provid2 === void 0 ? '' : _ref4$treasury_provid2,
    _ref4$treasury_delega2 = _ref4.treasury_delegate_draft,
    treasury_delegate_draft = _ref4$treasury_delega2 === void 0 ? '' : _ref4$treasury_delega2,
    _ref4$savingConfig = _ref4.savingConfig,
    savingConfig = _ref4$savingConfig === void 0 ? false : _ref4$savingConfig,
    _ref4$configNotice = _ref4.configNotice,
    configNotice = _ref4$configNotice === void 0 ? '' : _ref4$configNotice,
    _ref4$tab = _ref4.tab,
    tab = _ref4$tab === void 0 ? 'transfers' : _ref4$tab;
  var rows = Array.isArray(transfers) ? transfers : [];
  var activeTab = ['transfers', 'addresses', 'config'].includes(tab) ? tab : 'transfers';
  var needsApiKey = !loading && apiKeyConfigured === false;
  var needsAccount = !loading && !needsApiKey && account === null;
  var ready = !needsApiKey && !needsAccount && !loading;
  var body = '';
  if (loading) {
    body = "<p class=\"admin-payments-empty\">Loading pending transfers\u2026</p>";
  } else if (needsApiKey) {
    body = apiKeyPanel(apiKeyText, savingApiKey);
  } else if (needsAccount) {
    body = setupPanel(creating, restoring, restoreText);
  } else if (activeTab === 'addresses') {
    body = depositSection(depositAddresses);
  } else if (activeTab === 'config') {
    body = configTab({
      account: account,
      fulfillment_mode: fulfillment_mode,
      payout_mode: payout_mode,
      treasury_provider_publickeys: treasury_provider_publickeys,
      treasury_delegate_publickeys: treasury_delegate_publickeys,
      treasury_provider_draft: treasury_provider_draft,
      treasury_delegate_draft: treasury_delegate_draft,
      savingConfig: savingConfig,
      configNotice: configNotice
    });
  } else {
    body = transfersTab({
      rows: rows,
      search: search,
      purpose: purpose,
      advancing: advancing,
      page: page,
      total: total
    });
  }
  var refreshDisabled = loading || advancing || creating || restoring || savingApiKey || savingConfig ? 'disabled' : '';
  return "\n    <div class=\"admin-payments-page\">\n      <div class=\"admin-payments-header\">\n        <div class=\"admin-payments-heading\">\n          <h1>Payments</h1>\n          ".concat(ready ? paymentsTabs(activeTab) : '', "\n        </div>\n        ").concat(ready ? "<button type=\"button\" class=\"admin-button-icon\" id=\"admin-payments-refresh\" ".concat(refreshDisabled, " title=\"Refresh payments\" aria-label=\"Refresh payments\">\n                <i class=\"fa-solid fa-rotate").concat(loading ? ' fa-spin' : '', "\" aria-hidden=\"true\"></i>\n              </button>") : '', "\n      </div>\n      ").concat(error ? "<div class=\"admin-payments-error\">".concat(escapeHtml(error), "</div>") : '', "\n      ").concat(body, "\n    </div>\n  ");
};